(function($){
	$(document).ready(function(){

		var openRegionMenu = function( e ){
			if ( e.type == 'click' ) {
				e.preventDefault();
			}
			var menu = $( this ).closest( '.region-dropdown' );
			var open = menu.attr( 'aria-expanded' ) == 'true';

			var next = open ? 'false' :'true';
			menu.attr( 'aria-expanded', next );
			
		}
		
		$('.region-menu-btn').on( 'click', openRegionMenu );
		$('.region-menu-btn').on( 'keypress', openRegionMenu );

		$(document).on('click', function(event) {
			if (!$(event.target).closest('.region-dropdown').length) {
			  $('.region-dropdown').attr('aria-expanded', 'false');
			}
		  });
	});
})(jQuery);